import { render, staticRenderFns } from "./DeletePatientModal.vue?vue&type=template&id=70323f10"
import script from "./DeletePatientModal.vue?vue&type=script&lang=js"
export * from "./DeletePatientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports